<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'usersCrud'"
          :crudName="$t('vehicle.crud.title')"
          :newText="$t('vehicle.crud.newText')"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="$hasAbility('viatura.gerenciar')"
          :enableEdit="$hasAbility('viatura.gerenciar')"
          :enableDelete="$hasAbility('viatura.gerenciar')"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "vehiclesTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: ["id", "name", "plate", "brand", "model", "status", "actions"],
      tableData: [
        "id",
        "name",
        "color",
        "brand",
        "model",
        "vehicle_type_id",
        "renavam",
        "actual_km",
        "chassi",
        "plate",
        "code",
        "ares_frota_id",
        "current_vehicle_position_type",
        "status",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "name", "plate", "brand", "model", "status"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t('vehicle.crud.headings.id'),
          name: this.$t('vehicle.crud.headings.name'),
          plate: this.$t('vehicle.crud.headings.plate'),
          brand: this.$t('vehicle.crud.headings.brand'),
          model: this.$t('vehicle.crud.headings.model'),
          status: this.$t('common.status'),
          actions: this.$t('common.actions'),
        },
        sortable: ["id", "name", "plate", "brand", "model", "status"],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: this.$t('vehicle.crud.filterBy'),
          defaultOption: this.$t('common.select'),
        },
        listColumns: {
          status: [
            {
              id: 1,
              text: this.$t('common.active'),
            },
            {
              id: 0,
              text: this.$t('common.inactive'),
            },
          ],
        },
        templates: {},
        requestFunction: function (data) {
          let requestData = {};

          console.log(this.$parent.$parent);

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["company"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "vehicles",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },
    query: function (query) {
      let columns = {
        id: "id",
        name: "name",
        plate: "plate",
        brand: "brand",
        model: "model",
        status: "status",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>